// Meta (Facebook) Pixel helper
export const FB_PIXEL_ID = '1374426524177378'

// Shared product data so every event reports consistent value/currency.
export const PRODUCT = {
  content_name: 'Enciclopedia Gluko Libre Argentina',
  content_category: 'Infoproducto',
  value: 19990,
  currency: 'ARS',
}

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

const FBEVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

/**
 * Initializes the Meta Pixel (once) and fires the initial PageView.
 *
 * Note: we deliberately do NOT use the verbatim official snippet, because it
 * does `getElementsByTagName('script')[0].parentNode.insertBefore(...)` and
 * assumes a <script> tag already exists in the document. In sandboxed/iframe
 * preview environments that array can be empty, making `s` undefined and
 * throwing "Cannot read properties of undefined (reading 'parentNode')".
 * Instead we stub the fbq queue and append the script safely to <head>.
 */
export function initPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  const f = window as any

  // Stub the fbq command queue (matches official Meta Pixel behavior).
  if (!f.fbq) {
    const n: any = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    f.fbq = n
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Inject the fbevents script safely (no dependency on an existing <script>).
  const alreadyLoaded = Array.from(document.scripts).some(
    (sc) => sc.src === FBEVENTS_SRC,
  )
  if (!alreadyLoaded) {
    const script = document.createElement('script')
    script.async = true
    script.src = FBEVENTS_SRC
    const parent =
      document.head ||
      document.getElementsByTagName('head')[0] ||
      document.body ||
      document.documentElement
    parent.appendChild(script)
  }

  window.fbq?.('init', FB_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export function pageview() {
  window.fbq?.('track', 'PageView')
}

/** Track a standard Meta event (PageView, ViewContent, AddToCart, InitiateCheckout, etc.). */
export function track(name: string, options: Record<string, unknown> = {}) {
  window.fbq?.('track', name, options)
}

/** Track a custom (non-standard) event. */
export function trackCustom(
  name: string,
  options: Record<string, unknown> = {},
) {
  window.fbq?.('trackCustom', name, options)
}
